module.exports = __webpack_public_path__ + "img/geren.19c8478b.png";